<template>
  <Modal
      v-model="_value"
      width="400"
      title="第三方监控确认续费服务期"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">

    <Form v-if="orderList.length == 0" ref="renewalOrderForm" :model="renewalOrder" :label-width="90">
      <FormItem prop="serviceDatetime" label="服务到期日期">
        <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="总金额">
        <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      <FormItem prop="billType" label="开票类型">
        <Select style="width: 100%;" v-model="renewalOrder.billType">
          <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input style="width: 100%;" v-model="renewalOrder.remark"
               type="textarea"
               placeholder="请输入备注"></Input>
      </FormItem>
    </Form>

    <Form v-else ref="renewalOrderForm" :model="orderList">
      <div v-for="item in orderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.vehicleInfo != null ? item.vehicleInfo.registrationNum : item.vehicleInfo.vin}}</label>
        </FormItem>
      </div>
      <FormItem prop="serviceDatetime" label="服务到期日期">
          <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="总金额">
        <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      <FormItem prop="monitoringServicePackage" label="订单类型">
          <Select style="width: 100%;" v-model="renewalOrder.monitoringServicePackage">
            <Option v-for="item in monitoringServicePackageOptions" :value="item.value" :key="item.value">
              {{item.label}}
            </Option>
          </Select>
      </FormItem>
      <FormItem prop="billType" label="开票类型">
        <Select style="width: 100%;" v-model="renewalOrder.billType">
          <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input style="width: 100%;" v-model="renewalOrder.remark"
               type="textarea"
               placeholder="请输入备注"></Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'monitoringserviceconfirmservicedatetimemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      renewalOrder: {
        id: null,
        serviceDatetime: null,
        billType: 1,
        totalAmount: 0,
        remark: null,
        monitoringServicePackage: 1
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null,

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      // 第三方监控订单类型
      monitoringServicePackageOptions: [
        { label: '基础版', value: 1 },
        { label: '标准版', value: 2 },
        { label: '专业版', value: 3 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'MonitoringServiceServ_ConfirmServiceDatetime'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        store.dispatch('MonitoringServiceServ_BatchConfirmServiceDatetime', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                totalAmount: this.renewalOrder.totalAmount,
                billType: this.renewalOrder.billType,
                monitoringServicePackage: this.renewalOrder.monitoringServicePackage,
                serviceDatetime: new Date(this.renewalOrder.serviceDatetime).Format('yyyy-MM-dd hh:mm:ss')
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认服务期</p>',
          onOk: () => {
            store.dispatch('MonitoringServiceServ_ConfirmServiceDatetime',
              { params: this.renewalOrder }).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        // console.log(this._listValue)
        this.orderList = this._listValue
        this.orderIds = []
        // console.log(this.orderList)
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
        } else {
          this.orderIds = []

          this.renewalOrder.id = null
          this.renewalOrder.serviceDatetime = null
          this.renewalOrder.billType = 1
          this.renewalOrder.receptDatetime = null
          this.renewalOrder.totalAmount = 0
          this.renewalOrder.remark = null
          this.renewalOrder.monitoringServicePackage = 1

          let renewalOrderId = this._initValue
          if (renewalOrderId) {
            store.dispatch('MonitoringServiceServ_GetDetail', {
              params: { id: renewalOrderId }
            }).then(() => {
              this.renewalOrder = store.getters.get_MonitoringService_GetDetailResult
              if (this.renewalOrder.serviceDatetime) {
                this.renewalOrder.serviceDatetime = new Date(this.renewalOrder.serviceDatetime)
              }
              this.renewalOrder.remark = null
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
